import { CurrentEmployeeActions } from "@gtmhub/employees";
import { EmployeeService } from "@gtmhub/employees/services/employee.service";
import { CurrentUserService } from "@gtmhub/users";
import { providerUpgradeFactory } from "@webapp/core/provider-upgrade/factories/provider-upgrade.factory";

export const EmployeeServiceProvider = {
  provide: EmployeeService,
  useFactory: providerUpgradeFactory("EmployeeService"),
  deps: ["$injector"],
};

export const CurrentUserServiceProvider = {
  provide: CurrentUserService,
  useFactory: providerUpgradeFactory("CurrentUserService"),
  deps: ["$injector"],
};

export const CurrentEmployeeActionsProvider = {
  provide: CurrentEmployeeActions,
  useFactory: providerUpgradeFactory("CurrentEmployeeActions"),
  deps: ["$injector"],
};
